<template>
    <div>
        <div class="uploadMethoRadio">
             <tl-radio
                name="uploadType"
                label="Bulk Upload"
                id="bulkUpload"
                value="bulkUpload"
                v-model="uploadMethod"
              />
              <tl-radio
                disabled
                name="uploadType"
                label="Manual Upload"
                id="manualUpload"
                value="manualUpload"
                v-model="uploadMethod"
              />
            </div>
            <div v-if="uploadMethod == 'bulkUpload'">
            <div class="download-btn marginbot-20">
              <download-button
                onclick="location.href=''"
              ></download-button>
            </div>
            <upload-file
              :apiUrl="bulkUploadUrl"
              @uploadTemplate="onUploadTemplate($event)"
              :params="requestParams"
            />
            </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            uploadMethod: "bulkUpload",
        }
    }
}
</script>
<style scoped>
.uploadMethoRadio {
  display: flex;
  margin-bottom: 2%;
}
</style>